import React from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, FormButtons, FormControl, TextControl } from '@clatter/ui';
import { useAuth } from "@clatter/platform";
import {
  createResourceCategory,
  updateResourceCategory,
} from '../../../store/resource-categories.slice';

const StyledResourceCategoryForm = styled.form`
  width: 480px;
`;

const ResourceCategoryForm = ({ editableItem, isEdit, onSuccess }) => {
  const dispatch = useDispatch();
  const { activeUser } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState,
  } = useForm({
    mode: 'onChange',
    defaultValues: editableItem,
  });

  const onSubmit = async (formData) => {
    dispatch(
      isEdit
        ? updateResourceCategory({ id: editableItem.id, documentId: editableItem.documentId, formData: { categoryName: formData.categoryName, c_updated_by: activeUser.email } })
        : createResourceCategory({ categoryName: formData.categoryName, c_created_by: activeUser.email }),
    ).then(() => {
      onSuccess();
    });
  };

  return (
    <StyledResourceCategoryForm onSubmit={handleSubmit(onSubmit)}>
      <FormControl label="Category name" error={errors.categoryName}>
        <TextControl
          {...register('categoryName', {
            required: { value: true, message: 'Field is required' },
          })}
          placeholder="Enter category name"
        />
      </FormControl>
      <FormButtons>
        <Button
          disabled={!formState.isValid || !formState.isDirty}
          type="submit"
        >
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </FormButtons>
    </StyledResourceCategoryForm>
  );
};

export default ResourceCategoryForm;
